import React from 'react';
import min from 'lodash/min';
import max from 'lodash/max';
import { CusEcharts } from '@/components/AsyncComponent';
import type { ECOption } from '@/components/CusEcharts';

const AMOUNT_GAP_RATIO = 0.15;

const OpenJobArea = React.memo(
  (props: { areaData?: { name: string; value: number }[] }) => {
    const { areaData } = props;
    const lineChartRef = React.useRef(null);

    const lineConfig = React.useMemo<ECOption | undefined>(() => {
      if (!areaData || areaData.length <= 0) return;
      const dataList = areaData.map((item) => item.value);
      const maxVal = max(dataList) || NaN;
      const minVal = min(dataList) || NaN;
      const gap = (maxVal - minVal) * AMOUNT_GAP_RATIO;

      const chartData = areaData.map(({ name, value }) => ({
        category: name,
        value,
      }));
      const chartGapData = areaData.map(({ name, value }) => ({
        category: name,
        value: value - gap,
      }));

      return {
        grid: {
          show: false,
          top: 0,
          bottom: 0,
          left: 0,
          right: 0,
        },
        xAxis: {
          type: 'category',
          show: false,
          boundaryGap: 0,
        },
        yAxis: {
          type: 'value',
          show: false,
        },
        series: [
          {
            type: 'line',
            silent: true,
            data: chartData,
            smooth: true,
            cursor: 'default',
            showSymbol: false,
            emphasis: { disabled: true },
            itemStyle: {
              color: '#008489',
            },
            lineStyle: { width: 1 },
          },
          {
            type: 'line',
            silent: true,
            data: chartGapData,
            smooth: true,
            cursor: 'default',
            emphasis: { disabled: true },
            itemStyle: {
              color: 'transparent',
              opacity: 0,
            },
            areaStyle: {
              origin: 'start',
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: '#008489',
                  },
                  {
                    offset: 1,
                    color: '#cbe6e7',
                  },
                ],
              },
            },
          },
        ],
      };
    }, [areaData]);

    if (!lineConfig) {
      return null;
    }

    return (
      <div className="w-11 h-8 ml-4">
        <CusEcharts chartRef={lineChartRef} config={lineConfig} />
      </div>
    );
  },
);

export default OpenJobArea;
